import { Component, Input } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
import { EventsProvider } from '../../providers/events/events';
import { LocationsProvider } from '../../providers/locations/locations';
import { NavController, PopoverController } from 'ionic-angular';
import moment from 'moment';
import { AttendPage } from '../../pages/attend/attend';
import { AppState } from '../../config/state';
import { LoginProvider } from '../../providers/login/login';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Generated class for the CoEventCheckInComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-check-in',
  templateUrl: 'co-event-check-in.html',
  inputs: ['locationId']
})
export class CoEventCheckInComponent {
  @Input('locationId') locationId;
  currentLocation: any;
  todaysDate: any;
  todaysEvents: any;
  currentTime: any;
  clientKeyword: string;

  constructor(private config: ConfigProvider, private eventsProvider: EventsProvider, private locationProvider: LocationsProvider, public navCtrl: NavController, private popoverCtrl: PopoverController, private state : AppState, private login: LoginProvider, private toast: ToastAlertsProvider) {
    this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
  }

  ngOnInit() {

    if (!this.locationId) {
      this.locationId = this.state.locationId;
    }
    console.log(this.state, this.locationId)
    this.displayTime();
    this.getLocationInfo();
    this.getTodaysEvents();
  }

  getLocationInfo() {
    this.locationProvider.getLocation(parseInt(this.locationId)).then((res) => {
      this.currentLocation = res;
      this.clientKeyword = res.parentKeyword;
    })
  }

  getTodaysEvents() {
    let eventQueryArgs = `startDate: "${moment(this.todaysDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.todaysDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")}", locationId: ${parseInt(this.locationId)}`;
    this.eventsProvider.getEvents(eventQueryArgs).then((res) => {
      let hourObject = res.allEvents.reduce((red, event) => {
        let currentEventTime = moment(event.eventStart).format("HH:mm").toString();
        if (!red[currentEventTime]) {
          red[currentEventTime] = [];
        };
        red[currentEventTime].push(event);

        return red;
      }, {});

      let hourArray = Object.keys(hourObject).map((key) => {
        return hourObject[key];
      });

      this.todaysEvents = hourArray;
    });
  }

  displayTime() {
    this.currentTime = moment();
    setInterval(() => {
      this.currentTime = moment();
    }, 60000);
  }

  getEventTime(start) {
    let diff = moment(start).diff(this.currentTime, 'minutes');
    if (diff > 30) {
      return "";
    }
    return diff;
  }

  goToCheckinPage(event) {
    this.login.requireLogin(() => {
      this.toast.showAlert('Success', 'Successfully checked in for this event', 'success', 3000);
    }, undefined, this.state.pinless);
  }

  goToBranchEvents() {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(AttendPage, { locationId: this.locationId, locationName: this.currentLocation.name, filter: { tracker: true, location: [`${this.locationId}`] }, eventView: 'day' });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/co-event-check-in/co-event-check-in.ts